import Vue from "vue";

Vue.directive("readmore",
    {
        inserted(el, binding)
        {
            el.classList.add("rm-clamp");
            const btn = document.createElement("button");

            btn.type = "button";
            btn.className = "rm-toggle readmore";
            btn.textContent = "Weiterlesen";
            btn.hidden = true;
            el.insertAdjacentElement("afterend", btn);

            el._rmVal = binding.value;
            const isMobile = () => matchMedia("(max-width:768px)").matches;

            const getMax = () =>
            {
                const val = el._rmVal;

                if (typeof val === "number")
                {
                    return `${val}vh`;
                }

                if (typeof val === "string" && val.trim())
                {
                    return val;
                }

                return "25vh";
            };

            function update()
            {
                const expanded = el.classList.contains("-expanded");

                if (!isMobile())
                {
                    el.classList.remove("-expanded", "rm-clamped");
                    btn.hidden = true;
                    btn.setAttribute("aria-expanded", "false");
                    btn.textContent = "Weiterlesen";
                    return;
                }
                // apply clamp only when not expanded
                el.style.maxHeight = expanded ? "" : getMax();
                // +1 avoids subpixel off-by-one
                const overflow = !expanded && (el.scrollHeight > el.clientHeight + 1);

                el.classList.toggle("rm-clamped", overflow);
                btn.hidden = !(overflow || expanded);
                btn.textContent = expanded ? "Weniger anzeigen" : "Weiterlesen";
                btn.setAttribute("aria-expanded", String(expanded));
            }

            btn.addEventListener("click", () =>
            {
                el.classList.toggle("-expanded");
                update();
            });

            window.addEventListener("resize", update, {
                passive: true
            });
            requestAnimationFrame(update);
        },

        update(el, binding)
        {
            el._rmVal = binding.value;
            el._rmUpdate && el._rmUpdate();
        }
    });
